import React from "react";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import css from "./cpSourcingMobile.module.css";
import "./tokens.css";

// Shared sheet chrome: scrim, 20px top radius, 320ms slide. Copied from the
// Partners mobile view so both modules present filters identically.
//
// Closing via the scrim or the X is always a *discard* — callers that need to
// commit state must do it in their own footer button.
export default function BottomSheet({ open, title, onClose, footer, children }) {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      transitionDuration={320}
      PaperProps={{
        className: "cpSourcingMobileRoot",
        sx: {
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          maxHeight: "85vh",
          boxShadow: "0 8px 24px rgba(16,24,40,.12)",
        },
      }}
      sx={{ ".MuiBackdrop-root": { background: "rgba(52,64,84,.7)" } }}
    >
      <div className={css.sheetHeader}>
        <span className={css.sheetTitle}>{title}</span>
        <button
          type="button"
          className={css.sheetClose}
          aria-label="Close"
          onClick={onClose}
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </button>
      </div>
      <div className={css.sheetBody}>{children}</div>
      {footer && <div className={css.sheetFooter}>{footer}</div>}
    </Drawer>
  );
}
